import { Theme } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { colors } from '../../../assets/theme/palette';

interface Props {
  isOnChangePeriod?: boolean;
}

export const useStyles = makeStyles<Theme, Props>(() => ({
  container: {
    height: '290px',
  },
  navigationButtons: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 24,
    marginRight: ({ isOnChangePeriod }) => (isOnChangePeriod ? 0.875 : 0),
  },
  navigationButton: {
    margin: -10,
  },
  titleBox: {
    minWidth: 153,
    textAlign: 'center',
    margin: ({ isOnChangePeriod }) => `0 ${isOnChangePeriod ? 1 : 0}`,
  },
  title: {
    fontWeight: 'bold',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& span': {
      padding: '0 48px',
    },
  },
  arrow: {
    color: colors.primary.main,
    cursor: 'pointer',
  },
  timeContainer: {
    overflow: 'auto',
  },
  alwaysShowScrollbar: {
    '& *::-webkit-scrollbar': {
      '-webkit-appearance': 'none',
    },
    '& *::-webkit-scrollbar:vertical': {
      width: 11,
    },
    '& *::-webkit-scrollbar:horizontal': {
      height: 11,
    },
    '& *::-webkit-scrollbar-thumb': {
      borderRadius: '8px',
      border: '2px solid white' /* can't be transparent */,
      backgroundColor: 'rgba(0, 0, 0, .5)',
      height: '20px !important',
      maxHeight: 20,
      minHeight: 20,
    },
    '& *::-webkit-scrollbar-corner': {
      background: 'transparent',
    },
    '& .track-horizontal': {
      opacity: '1 !important',
    },
    '& .track-vertical': {
      opacity: '1 !important',
    },
  },
  timeButton: {
    padding: '2px',
    width: 185,
    margin: '0 auto',

    '&:not(:last-child)': {
      marginBottom: 11,
    },
    '& span div': {
      fontSize: 18,
      lineHeight: '26px',
      padding: '9px 10px',
    },
  },
  selected: {
    '& button div': {
      backgroundColor: colors.primary.main,
      color: colors.basic.white,
    },
  },
  noAvailability: {
    color: colors.grey60,
    textAlign: 'center',
  },
}));
